





































import {Component, Mixins} from 'vue-mixin-decorator';
import {getModule} from 'vuex-module-decorators';
import {BaseComponent} from '@/mixins/BaseComponent';

import {EventBus} from '@/utils/EventBus';

import {ApiStore} from '@/store/Api.store';

@Component({
  components: {},
})
export default class RedirectConfirmDialog extends Mixins<BaseComponent>(BaseComponent) {
  private apiStore: ApiStore = getModule(ApiStore, this.$store);

  private redirectConfirmDialog = false;

  private mounted() {
    EventBus.Register(EventBus.Event.EthernetConnectionUpdated, async () => {
      if (this.remoteChanged && !this.apiStore.ConfigurableRemote) {
        this.redirectConfirmDialog = true;
      }
    });
  }

  get remoteChanged(): boolean {
    return this.apiStore.Remote !== window.location.host;
  }

  get redirectAddress(): string {
    return `${this.apiStore.Secured ? 'https' : 'http'}://${this.apiStore.Remote}${this.$route.path}`;
  }

  private redirect() {
    window.location.href = this.redirectAddress;
  }
}
